import Button from '@/common/components/Button';
import { useFilterParams } from '@/common/hooks/useFilterParams';
import { reportFilters } from '@/features/reports/constants/reportFilters.constant';
import { XIcon } from 'lucide-react';
import { Control, FieldErrors, UseFormResetField, UseFormWatch } from 'react-hook-form';
import { PermittedReportFilterData } from '../types/permittedReports.type';
import { useEffect, useState } from 'react';

interface ReportsFiltersFieldProp {
  control: Control;
  errors: FieldErrors;
  filterName: string;
  filterProps: PermittedReportFilterData
  resetField: UseFormResetField<any>;
  watch: UseFormWatch<any>
}

const ReportsFiltersField = ({ control, errors, filterName, filterProps, resetField, watch }: ReportsFiltersFieldProp) => {
  const { filterParams, setFilterParams } = useFilterParams();

  const companyValue = watch('client_company_id_eq')

  const [defaultCompanyValue, setDefaultCompanyValue] = useState(filterParams?.q?.client_company_id_eq);

  useEffect(() => {
   if (filterName.includes('client_branch_id_eq')) {
     resetField('client_branch_id_eq');
     setFilterParams((params) => ({ ...params, q: { ...params.q, 'client_branch_id_eq': undefined } }));
   }

   if (filterName.includes('client_company_branch_id_eq')) {
     resetField('client_company_branch_id_eq');
     setFilterParams((params) => ({ ...params, q: { ...params.q, 'client_company_branch_id_eq': undefined } }));
   }

   if (filterName.includes('client_equipment_id_eq') && companyValue?.value !== defaultCompanyValue?.value) {
     resetField('client_equipment_id_eq');
     setFilterParams((params) => ({ ...params, q: { ...params.q, 'client_equipment_id_eq': undefined } }));
     setDefaultCompanyValue(undefined);
   }
  }, [companyValue, filterName, defaultCompanyValue])

  return (
    <div className="flex w-full items-start">
      {(reportFilters[filterName as keyof typeof reportFilters] || reportFilters['default'])({
        control,
        errors,
        filterName,
        value: filterParams.q?.[filterName] || null,
        setFilterParams,
        filterProps,
      })}

      <Button
        type="button"
        variant="outline-error"
        className="size-[52px] px-2 mt-5 bg-black text-white-800 rounded-l-none"
        onClick={() => {
          resetField(filterName);
          setFilterParams((params) => ({ ...params, q: { ...params.q, [filterName]: undefined } }));
        }}
      >
        <XIcon className="size-5" />
      </Button>
    </div>
  );
};

export default ReportsFiltersField;
